import React from 'react';
import { WizardStep } from '../../stores/levelUpStore';
import { useLevelUpWizard } from '../../hooks/useLevelUpWizard';

// Step components (to be implemented in Week 3)
// For now, we'll create placeholder components
const WelcomeStep = React.lazy(() => import('./steps/WelcomeStep'));
const TierAchievementStep = React.lazy(() => import('./steps/TierAchievementStep'));
const AdvancementsStep = React.lazy(() => import('./steps/AdvancementsStep'));
const DomainCardsStep = React.lazy(() => import('./steps/DomainCardsStep'));
const SummaryStep = React.lazy(() => import('./steps/SummaryStep'));
const CompletionStep = React.lazy(() => import('./steps/CompletionStep'));

/**
 * Routes to the appropriate wizard step component based on current step
 */
export const WizardStepRouter: React.FC = () => {
  const { currentStep } = useLevelUpWizard();

  return (
    <React.Suspense fallback={<StepLoadingFallback />}>
      {currentStep === WizardStep.WELCOME && <WelcomeStep />}
      {currentStep === WizardStep.TIER_ACHIEVEMENT && <TierAchievementStep />}
      {currentStep === WizardStep.ADVANCEMENTS && <AdvancementsStep />}
      {currentStep === WizardStep.DOMAIN_CARDS && <DomainCardsStep />}
      {currentStep === WizardStep.SUMMARY && <SummaryStep />}
      {currentStep === WizardStep.COMPLETION && <CompletionStep />}
    </React.Suspense>
  );
};

/**
 * Loading fallback for lazy-loaded step components
 */
const StepLoadingFallback: React.FC = () => (
  <div className="wizard-step-loading">
    <div className="loading-spinner" />
    <p>Loading step...</p>
  </div>
);
